import styled from 'styled-components';

export const Container = styled.footer`
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #FFF;
  padding-top: 20px;
  padding-bottom: 10px;
  z-index: 100;
`;

export const Security = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 95%;
  margin: 0 auto;
  padding-bottom: 20px;
`;

export const SecurityImg = styled.img`
  display: block;
  width: 100%;
  max-width: 24px;
  margin-right: 9px;
`;

export const SecurityText = styled.p`
  color: #707070;
  font-size: 14px;
  font-weight: 700;
  margin: 0;
`

export const Copyright = styled.p`
  color: #707070;
  font-size: 14px;
  font-weight: 400;
  width: 85%;
  margin-left: auto;
  margin-right: auto;
  margin-top: 20px;
`
